module.exports = __webpack_public_path__ + "img/icon_deposit.c7c9ac9.webp";